(() => {
  if (window.__eonaVariantBadgeMarker) {
    window.__eonaVariantBadgeMarker();
    return;
  }

  const popularPackByHandle = Object.freeze({
    // Optional hard overrides: 'product-handle': '5'
  });

  const packCache = new Map();
  let isScheduled = false;

  const normalizePack = (value, fallback = '3') => {
    const match = String(value || '').match(/\b(3|5|10)\b/);

    if (!match || match[1] === '10') {
      return fallback;
    }

    return match[1];
  };

  const extractPackFromLabel = (label) => {
    const match = label.match(/\b(1|3|5|10)\s*vials?\b/);
    return match ? match[1] : null;
  };

  const getProductTags = async (handle) => {
    if (!handle || packCache.has(handle)) {
      return;
    }

    packCache.set(handle, null);

    try {
      const response = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });

      if (!response.ok) {
        throw new Error(`Product JSON failed: ${response.status}`);
      }

      const product = await response.json();
      const tags = Array.isArray(product.tags)
        ? product.tags
        : String(product.tags || '').split(',');
      const popularTag = tags
        .map((tag) => tag.trim().toLowerCase())
        .find((tag) => /^popular-pack-(3|5|10)$/.test(tag));

      packCache.set(handle, normalizePack(popularTag, '3'));
    } catch (error) {
      packCache.set(handle, '3');
    }

    window.__eonaVariantBadgeMarker();
  };

  const getPopularPack = (group) => {
    const picker = group.closest('variant-picker');
    const handle = picker?.getAttribute('handle') || '';
    const explicitPack = normalizePack(picker?.dataset.eonaPopularPack || popularPackByHandle[handle], '');

    if (explicitPack) {
      return explicitPack;
    }

    if (handle && !packCache.has(handle)) {
      getProductTags(handle);
    }

    return normalizePack(packCache.get(handle), '3');
  };

  const markVariantBadges = () => {
    isScheduled = false;

    document.querySelectorAll('.variant-picker__option-values').forEach((group) => {
      const popularPack = getPopularPack(group);
      let popularApplied = false;

      group.querySelectorAll('.block-swatch').forEach((swatch) => {
        const label = (swatch.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        const pack = extractPackFromLabel(label);

        swatch.removeAttribute('data-eona-pack-badge');

        if (pack === '10') {
          swatch.setAttribute('data-eona-pack-badge', 'best-price');
        } else if (!popularApplied && pack === popularPack) {
          swatch.setAttribute('data-eona-pack-badge', 'popular');
          popularApplied = true;
        }
      });
    });
  };

  const scheduleMark = () => {
    if (isScheduled) {
      return;
    }

    isScheduled = true;
    window.requestAnimationFrame(markVariantBadges);
  };

  window.__eonaVariantBadgeMarker = scheduleMark;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleMark, { once: true });
  } else {
    scheduleMark();
  }

  document.addEventListener('shopify:section:load', scheduleMark);

  const observer = new MutationObserver(scheduleMark);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
